import React from 'react';
import styles from './GepdecStory.module.css';

const GepdecStory = () => {
    return (
        <section className={styles.storySection}>
            <div className={styles.container}>
                <div className={styles.storyContent}>
                    {/* Image Section */}
                    <div className={styles.imageSection}>
                        <div className={styles.imageContainer}>
                            <img
                                src="/images/about-us.jpg"
                                alt="PISCESIA Modern Office"
                                className={styles.officeImage}
                            />
                        </div>

                        {/* Color Accent Squares */}
                        {/* <div className={styles.colorAccents}>
                            <div className={styles.greenSquare}></div>
                            <div className={styles.blueSquare}></div>
                        </div> */}
                    </div>

                    {/* Text Section */}
                    <div className={styles.textSection}>
                        <div className={styles.titleContainer}>
                            <h2 className={styles.storyTitle}>
                                <span className={styles.titleDark}>PISCESIA POWER</span>{' '}
                                <span className={styles.titleGreen}>About Us</span>
                            </h2>
                        </div>

                        <div className={styles.storyText}>
                            <p className={styles.paragraph}>
                            We are one of the fast-growing Engineering, Procurement, and Construction (EPC) 
                            firms in the Power and Electrical Infrastructure sector. Founded in 2012 and headquartered
                             in Lucknow, with a design centre in Noida, PPTPL is an ISO 9001:2008 certified organization. 
                             With expertise in Extra High Voltage (EHV) GIS substations, transmission and distribution lines, 
                             and tunnel electro-mechanical systems, the company provides integrated, end-to-end infrastructure 
                             solutions across the industry.
                            </p>

                            <p className={styles.paragraph}>
                                We undertake turnkey projects on a global scale, offering a complete range of services in Design, Testing, Manufacturing, Sourcing, Supply and Construction with our in-house expertise.

                            </p>
                            <p className={styles.paragraph}>
                                Our tunnel engineering expertise includes both electrical and mechanical solutions
                                for railways which includes Tunnel ventilation, SCADA system, Fire fighting system,
                                GIS substation and power supply.
                            </p>
                            <p className={styles.paragraph}>
                                Our clientele includes autonomous state authorities, state electricity boards,
                                railways and private organizations.
                            </p>
                        </div>

                        {/* <div className={styles.buttonContainer}>
                            <button 
                                className={styles.knowMoreButton}
                                aria-label="Learn more about PISCESIA's story and company journey"
                                type="button"
                            >
                                <span>KNOW MORE</span>
                                <svg 
                                    width="20" 
                                    height="20" 
                                    viewBox="0 0 24 24" 
                                    fill="none" 
                                    className={styles.buttonArrow}
                                    aria-hidden="true"
                                >
                                    <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                        </div> */}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GepdecStory;
